import { useSelector } from 'react-redux'
const isMobile = window.innerWidth < 700

export const MockHeader = ({ setSearch, search }) => {
    const user = useSelector(state => state.user)
    const { preview, previewLan } = useSelector(state => state.general)
    const theme = 'dark'

    return <header className='mock-header' style={{ zIndex: 1001 }}>
        <div className='logo-wrapper'>
            <img src={require(`../../style/imgs/header/${theme}/menu.webp`)} className='menu-icon' />
            <img src={require(`../../style/imgs/header/${theme}/logo.webp`)} className='logo' />
        </div>
        {!isMobile && <div className='search-wrapper' >
            {preview && previewLan === 'he' ? <div className='search search-he'>
                <input type="text" style={{ textAlign: 'right' }} placeholder='חיפוש' onChange={(ev) => setSearch(ev.target.value)} value={search} />
                <div>
                    <img src={require(`../../style/imgs/header/${theme}/search.webp`)} />
                </div>
            </div> :
                <div className='search'>
                    <input type="text" style={{ textAlign: 'left' }} placeholder='Search' onChange={(ev) => setSearch(ev.target.value)} value={search} />
                    <div><img src={require(`../../style/imgs/header/${theme}/search.webp`)} /></div>
                </div>}
            <div className='mic'><img src={require(`../../style/imgs/header/${theme}/mic.webp`)} /></div>
        </div>}
        <div className='logo-wrapper'>
            {isMobile ? <img src={require(`../../style/imgs/header/${theme}/search.webp`)} /> :
                <img src={require(`../../style/imgs/header/${theme}/bell.webp`)} />}
            <img src={user.img || require('../../style/imgs/header/user.webp')} className='user-icon circle' />
        </div>
    </header >
}